import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getTenantWorkflows } from 'services/api/AccessManagerAPI';

export const useGetTenantWorkflows = (isEnabled = true) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.tenantWorkflows,
        queryFn: () => getTenantWorkflows(),
        enabled: isEnabled,
    });

    return {
        tenantWorkflows: data,
        isTenantWorkflowsLoading: isLoading,
        isTenantWorkflowsFetching: isFetching,
        ...rest,
    };
};
